import urlPrefix from "./apiPrefix";

export const postCashRegisterRegistry = () => `${urlPrefix.value}/tax-web-control/api/cash-register/registry`;
export const postCashRegisterExport = () => `${urlPrefix.value}/tax-web-control/api/cash-register/export`;
